"use strict";
/**
 * LinkedIn Sales Navigator Filter Types
 * Values are stored as exact LinkedIn UI labels for extension to use directly
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyLinkedInFilters = void 0;
/**
 * Helper to create empty filters object
 */
const createEmptyLinkedInFilters = () => ({
    keywords: "",
    company: { included: [], excluded: [] },
    // currentCompany: { included: [], excluded: [] },
    // pastCompany: { included: [], excluded: [] },
    companyHeadquarters: { included: [], excluded: [] },
    companyHeadcount: { included: [], excluded: [] },
    companyType: { included: [], excluded: [] },
    function: { included: [], excluded: [] },
    jobTitle: { included: [], excluded: [] },
    // currentJobTitle: { included: [], excluded: [] },
    // pastJobTitle: { included: [], excluded: [] },
    seniorityLevel: { included: [], excluded: [] },
    yearsInCurrentCompany: { included: [], excluded: [] },
    yearsInCurrentPosition: { included: [], excluded: [] },
    geography: { included: [], excluded: [] },
    industry: { included: [], excluded: [] },
    school: { included: [], excluded: [] },
    profileLanguage: { included: [], excluded: [] },
    yearsOfExperience: { included: [], excluded: [] },
    firstName: "",
    lastName: "",
    changedJobs: null,
    postedOnLinkedIn: null,
    openToWork: null,
    postalCode: null,
});
exports.createEmptyLinkedInFilters = createEmptyLinkedInFilters;
